// extracted by mini-css-extract-plugin
export default {"button":"FacebookLoginButton_button__QGbDF"};